module.exports = __webpack_public_path__ + "static/img/met-bg.6461f32f.png";